import { mutator } from "satcheljs";
import store from "../store/store";
import changeFabricDensityAction, { type MUTATE_FABRIC_DENSITYActionMessage, } from "../actions/changeDensity";

/* eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> Please use a mutatorAction if action is defined in the same package */
const defaultExport: (actionMessage: MUTATE_FABRIC_DENSITYActionMessage) => void = mutator(changeFabricDensityAction, actionMessage => {
    const { densityMode, density } = actionMessage;
    store().density = {
        ...density,
        components: {
            ...(density.components || {}),
            CommandBar: {
                styles: { root: { backgroundColor: store().palette?.neutralLighter } },
            },
        },
    };
    store().densityMode = densityMode;
});
export default defaultExport;
